import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import SelectSingle from '@ui/select/react-select/select-single';
import { memo, useCallback, useMemo } from 'react';
import { useAppSelector } from '@/store/hooks';
import useLanguageParams from '@/utils/use-language-params';
import { generatePath, useMatches, useNavigate } from 'react-router-dom';
import { selectWorkingProject } from '@/store/slices/project/selectors';
import TranslateLangsV2 from '@/utils/translate-langs-v2.json';

const LANGUAGE_OPTIONS_V2 = TranslateLangsV2.map((lang) => {
  return {
    value: lang.code,
    label: lang.label,
    meta: { value: lang.code, label: lang.label },
  };
});

function LanguageSwitcher() {
  const language = useLanguageParams();
  const navigate = useNavigate();
  const matches = useMatches();
  const workingProject = useAppSelector(selectWorkingProject);
  const languages = useMemo(() => {
    return Array.from(new Set(workingProject?.sessions.flatMap((s) => s.languages) ?? []));
  }, [workingProject]);

  const changeLanguage = useCallback(
    (language: string) => {
      const match = matches.find((match) => match.id === 'campaign-editor');
      if (match) {
        navigate(
          generatePath('/project/edit/:projectUuid/:language/campaigns/:campaignUuid/edit', {
            projectUuid: String(match.params.projectUuid),
            campaignUuid: String(match.params.campaignUuid),
            language,
          })
        );
      }
    },
    [matches, navigate]
  );

  return languages.length > 1 ? (
    <Container padding="0 12px">
      <Container style={{ transition: 'border-radius 350ms' }} borderRadius={'12px'} design="GlobalCont2">
        <Container padding="16px" className="flex flex-column gap-8">
          <Text className="H6" design="GlobalIcoText1">
            Language
          </Text>
          <SelectSingle
            value={language ?? 'en'}
            options={LANGUAGE_OPTIONS_V2.filter((lang) => languages.includes(lang.value))}
            onChange={changeLanguage}
            placeholder=""
            width="100%"
          />
        </Container>
      </Container>
    </Container>
  ) : null;
}

export default memo(LanguageSwitcher);
